import { Link } from 'react-router-dom';

/**
 * Brand logo. Two variants:
 *   - <Logo />            -> dark wordmark on light surfaces (default)
 *   - <Logo variant="white" /> -> white wordmark for dark backgrounds
 *
 * Pass `linkTo={false}` to render as a plain span (e.g. in hero sections
 * where the wrapping <a> would conflict).
 */
export default function Logo({
  variant = 'dark',
  size = 'md',
  linkTo = '/',
  className = '',
}) {
  const src = variant === 'white' ? '/Logo-Light.svg' : '/Logo-Dark.svg';
  const heightClass = size === 'lg' ? 'h-10' : size === 'sm' ? 'h-6' : 'h-8';
  const img = (
    <img
      src={src}
      alt="RankOnAI"
      className={`${heightClass} w-auto select-none ${className}`}
      draggable="false"
    />
  );
  if (!linkTo) return img;
  return (
    <Link to={linkTo} className="inline-flex items-center">
      {img}
    </Link>
  );
}
